/* Cocoony CH · PDP Sérum EGF NAD+ : minuteur (minuit Europe/Zurich), galerie, packs + ajout panier (remises automatiques),
   accordéons, vidéos d'avis, frise « Tu camino », carrousel d'avis. */
(function () {
  if (window.__egPdp) return; window.__egPdp = true;
  function $all(s, r) { return [].slice.call((r || document).querySelectorAll(s)); }
  function ready(fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); }
  ready(function () {
    /* Minuteur : fin à minuit heure du marché, redémarre chaque jour (masqué après la date de fin si renseignée). */
    function tzNow(tz) {
      try {
        var p = new Intl.DateTimeFormat('en-US', { timeZone: tz, hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' }).formatToParts(new Date());
        var o = {}; p.forEach(function (x) { o[x.type] = x.value; });
        return { date: o.year + '-' + o.month + '-' + o.day, secs: (parseInt(o.hour, 10) % 24) * 3600 + parseInt(o.minute, 10) * 60 + parseInt(o.second, 10) };
      } catch (e) { var d = new Date(); return { date: d.toISOString().slice(0, 10), secs: d.getHours() * 3600 + d.getMinutes() * 60 + d.getSeconds() }; }
    }
    function two(n) { return (n < 10 ? '0' : '') + n; }
    var timers = $all('[data-eg-timer]');
    function tick() {
      timers.forEach(function (el) {
        var n = tzNow(el.getAttribute('data-tz') || 'Europe/Zurich'), until = el.getAttribute('data-until') || '';
        if (until && n.date > until) { el.style.display = 'none'; return; }
        var rest = 86400 - n.secs; if (rest >= 86400) rest = 0;
        var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
        if (h) h.textContent = two(Math.floor(rest / 3600)); if (m) m.textContent = two(Math.floor(rest / 60) % 60); if (s) s.textContent = two(rest % 60);
      });
    }
    if (timers.length) { tick(); setInterval(tick, 1000); }

    /* Galerie */
    $all('[data-eg-gal]').forEach(function (g) {
      var sl = g.querySelector('.eg-gal__slides'), th = $all('.eg-gal__thumb', g), n = th.length;
      if (!n) return;
      function mark(i) { th.forEach(function (t, k) { t.classList.toggle('is-on', k === i); }); }
      th.forEach(function (t, i) { t.addEventListener('click', function () { sl.scrollTo({ left: sl.clientWidth * i, behavior: 'smooth' }); mark(i); }); });
      var w; sl.addEventListener('scroll', function () { clearTimeout(w); w = setTimeout(function () { mark(Math.round(sl.scrollLeft / (sl.clientWidth || 1))); }, 80); }, { passive: true });
    });

    /* Packs + ajout : une seule variante, le pack règle la quantité ; les remises automatiques Shopify font le palier. */
    $all('[data-eg-buy]').forEach(function (b) {
      var packs = $all('[data-pack]', b), atc = b.querySelector('[data-atc]'), err = b.querySelector('[data-err]');
      var sel = b.querySelector('[data-pack].is-on') || packs[0];
      function paint() { packs.forEach(function (p) { var on = p === sel; p.classList.toggle('is-on', on); p.setAttribute('aria-checked', on ? 'true' : 'false'); }); }
      packs.forEach(function (p) {
        p.addEventListener('click', function () { sel = p; paint(); });
        p.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); sel = p; paint(); } });
      });
      function fail(e) { atc.classList.remove('is-busy'); if (err) { err.textContent = (e && e.message) || b.getAttribute('data-err-msg') || ''; err.hidden = false; } }
      function post(url, body) {
        return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || ''); return j; }); });
      }
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/', SEC = 'cart-drawer,cart-icon-bubble';
      if (atc) atc.addEventListener('click', function () {
        var q = parseInt(sel.getAttribute('data-qty'), 10) || 1, vid = parseInt(b.getAttribute('data-variant'), 10);
        atc.classList.add('is-busy'); if (err) err.hidden = true;
        post('cart/add.js', { items: [{ id: vid, quantity: q }] })
          .then(function () { return post('cart/update.js', { updates: {}, sections: SEC, sections_url: location.pathname }); })
          .then(function (st) {
            atc.classList.remove('is-busy');
            var d = document.querySelector('cart-drawer');
            if (d && d.renderContents && st && st.sections) { st.id = vid; d.classList.remove('is-empty'); d.renderContents(st); }
            else location.href = root + 'cart';
          })
          .catch(fail);
      });
      paint();
    });

    /* Accordéons (produit + FAQ) */
    $all('[data-eg-acc]').forEach(function (list) {
      list.addEventListener('click', function (e) {
        var q = e.target.closest('[data-q]'); if (!q || !list.contains(q)) return;
        var it = q.parentElement, open = it.classList.contains('is-open');
        it.classList.toggle('is-open', !open); q.setAttribute('aria-expanded', open ? 'false' : 'true');
        var a = it.querySelector('[data-a]'); if (a) a.hidden = open;
      });
    });

    /* Vidéos d'avis : lecture au clic, une seule à la fois */
    var vids = $all('[data-eg-vid]');
    vids.forEach(function (box) {
      var v = box.querySelector('video');
      function play() { vids.forEach(function (o) { if (o !== box) { var ov = o.querySelector('video'); ov.pause(); o.classList.remove('is-playing'); ov.controls = false; } }); box.classList.add('is-playing'); v.controls = true; v.play(); }
      $all('.eg-vid__hit,.eg-vid__play', box).forEach(function (b) { b.addEventListener('click', play); });
      v.addEventListener('ended', function () { box.classList.remove('is-playing'); v.controls = false; });
    });

    /* Frise : apparition au défilement + remplissage de la ligne */
    $all('[data-eg-road]').forEach(function (s) {
      var tl = s.querySelector('.eg-road__tl'), fill = s.querySelector('.eg-road__fill'), items = $all('.eg-road__it', s);
      if (!('IntersectionObserver' in window)) return;
      s.classList.add('is-js');
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } }); }, { threshold: .15 });
      items.forEach(function (it) { io.observe(it); });
      function upd() {
        var r = tl.getBoundingClientRect(), vh = window.innerHeight, last = items[items.length - 1];
        var max = last.offsetTop + 15 - 30, done = Math.min(Math.max(vh * .6 - r.top - 30, 0), max);
        fill.style.height = done + 'px';
      }
      window.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', upd); upd();
    });

    /* Carrousel d'avis (flèches + glisser) */
    $all('[data-eg-rev]').forEach(function (s) {
      var clip = s.querySelector('.eg-rev__clip'), track = s.querySelector('.eg-rev__track'), cards = $all('.eg-rcard', track), cur = 0;
      function step() { return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : clip.clientWidth; }
      function maxI() { var vis = Math.max(1, Math.floor((clip.clientWidth + 1) / step())); return Math.max(0, cards.length - vis); }
      function go(i) { var m = maxI(); cur = i < 0 ? m : (i > m ? 0 : i); track.style.transform = 'translateX(' + (-cur * step()) + 'px)'; }
      s.querySelector('[data-dir="-1"]').addEventListener('click', function () { go(cur - 1); });
      s.querySelector('[data-dir="1"]').addEventListener('click', function () { go(cur + 1); });
      var sx = 0;
      track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      track.addEventListener('touchend', function (e) { var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1)); }, { passive: true });
      window.addEventListener('resize', function () { go(Math.min(cur, maxI())); });
    });
  });
})();
